import { render } from "./input.html?vue&type=template&id=1d16340f&ts=true"
import script from "./input.ts?vue&type=script&lang=ts"
export * from "./input.ts?vue&type=script&lang=ts"

import "./input.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__